import { Viewer } from "~/providers/viewer";

export const Username = (viewer?: Viewer) => {
  return viewer?.name || viewer?.email || "Anonymous User";
};
